module.exports = __webpack_public_path__ + "static/img/fotos.090fd30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fotos.png
// module id = 6nQY
// module chunks = 1